module.exports = __webpack_public_path__ + "img/111ne.67876321.svg";